export default "/assets/images/column-image8.a3291be10b98d4fe.webp";